import { render, staticRenderFns } from "./productList.vue?vue&type=template&id=f32a8234&scoped=true&"
import script from "./productList.vue?vue&type=script&lang=ts&"
export * from "./productList.vue?vue&type=script&lang=ts&"
import style0 from "./productList.vue?vue&type=style&index=0&id=f32a8234&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f32a8234",
  null
  
)

export default component.exports